import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiSearch } from 'react-icons/fi';

const DakhlUtareFeeReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {};
  const [reportType, setReportType] = useState('all');

  const tableData = [
    { id: 1, date: '01/04/2025', name: 'उत्पन्नाचा दाखला', moneyTaken: 'true', fee: 100, option: 'Namuna No. 7' },
    { id: 12, date: '01/04/2025', name: 'नमुना ८ (व्यक्तिगत)', moneyTaken: 'true', fee: 0, option: '' },
    { id: 12, date: '01/04/2025', name: 'तन्माचा दाखला', moneyTaken: 'true', fee: 20, option: 'Namuna No. 7' },
    { id: 12, date: '01/04/2025', name: 'तन्माचा दाखला', moneyTaken: 'true', fee: 12, option: 'Namuna No. 7' },
    { id: 12, date: '01/04/2025', name: 'निराधार योजनेसाठी वयाचा दाखला', moneyTaken: 'true', fee: 10, option: 'Namuna No. 7' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      {/* Top Header Row with Back Button */}
      <div className="bg-white p-4 shadow-sm flex justify-between items-center">
         <h1 className="text-xl font-bold text-gray-800">ग्रामपंचायत: {grampanchayatName || "नांव उपलब्ध नाही"}</h1>
         <button 
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 font-medium flex items-center gap-2 transition-colors"
          >
            <FiArrowLeft />
            मागे जा
          </button>
      </div>

      {/* Main Content Card matching the image style */}
      <div className="max-w-7xl mx-auto p-4 md:p-6">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
            {/* Header matching image */}
            <div className="bg-[#267c77] text-white p-4">
                <h2 className="text-lg font-semibold">दाखले उतारे प्रिंट माहिती</h2>
            </div>
            
            {/* Filters Section */}
            <div className="p-6 border-b border-gray-100">
                {/* Date Row */}
                <div className="flex flex-wrap items-center gap-6 mb-6">
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 font-medium">दिनांका पासून :</label>
                        <div className="relative">
                            <input type="date" defaultValue="2025-04-01" className="border border-gray-300 rounded px-3 py-1.5 focus:outline-none focus:border-[#267c77] w-40" />
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 font-medium">दिनांका पर्यंत :</label>
                        <div className="relative">
                            <input type="date" defaultValue="2025-04-01" className="border border-gray-300 rounded px-3 py-1.5 focus:outline-none focus:border-[#267c77] w-40" />
                        </div>
                    </div>
                     <button className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-6 py-1.5 rounded transition-colors text-sm font-medium">
                        दाखवा
                    </button>
                </div>

                {/* Radio and Dropdown Row */}
                <div className="flex flex-wrap items-center gap-6 bg-gray-50 p-4 rounded-lg border border-gray-100">
                    <div className="flex items-center gap-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input 
                                type="radio" 
                                name="reportType" 
                                checked={reportType === 'all'} 
                                onChange={() => setReportType('all')}
                                className="w-4 h-4 text-[#267c77] focus:ring-[#267c77]" 
                            />
                            <span className="text-gray-700">सर्व</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input 
                                type="radio" 
                                name="reportType" 
                                checked={reportType === 'type'} 
                                onChange={() => setReportType('type')}
                                className="w-4 h-4 text-[#267c77] focus:ring-[#267c77]" 
                            />
                            <span className="text-gray-700">प्रकारानुसार</span>
                        </label>
                    </div>
                    <div className="flex items-center gap-2 flex-1 max-w-md">
                        <select 
                            disabled={reportType === 'all'}
                            className="w-full border border-gray-300 rounded px-3 py-1.5 focus:outline-none focus:border-[#267c77] disabled:bg-gray-100 disabled:text-gray-400"
                        >
                            <option>प्रकार निवडा</option>
                            <option>उत्पन्नाचा दाखला</option>
                            <option>जन्म दाखला</option>
                            <option>मृत्यू दाखला</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-[#267c77] text-white"> {/* Using a blueish shade for table header to match image if preferred, or sticking to primary. Image shows dark blue header for table. Let's use a standard dark blue for table header as shown in image */}
                            <th className="p-3 border-r border-white/30 text-center w-24">जावक नं.</th>
                            <th className="p-3 border-r border-white/30 text-center w-32">दिनांक</th>
                            <th className="p-3 border-r border-white/30">रिर्पोटचे नाव</th>
                            <th className="p-3 border-r border-white/30 w-32">पैसे घेतले का?</th>
                            <th className="p-3 border-r border-white/30 w-24">दाखला फी</th>
                            <th className="p-3 text-center w-40">पर्याय</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index) => (
                            <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                                <td className="p-3 text-center text-gray-700 border-r border-gray-100">{row.id}</td>
                                <td className="p-3 text-center text-gray-700 border-r border-gray-100">{row.date}</td>
                                <td className="p-3 text-gray-700 border-r border-gray-100 font-medium">{row.name}</td>
                                <td className="p-3 text-gray-700 border-r border-gray-100">{row.moneyTaken}</td>
                                <td className="p-3 text-gray-700 border-r border-gray-100">{row.fee}</td>
                                <td className="p-3 text-center">
                                    {row.option && (
                                        <button 
                                            onClick={() => navigate('/asthapan/grampanchayat/receipt', { 
                                                state: { 
                                                    receiptData: {
                                                        grampanchayatName: grampanchayatName,
                                                        date: row.date,
                                                        payerName: "संग्राम", // Placeholder, ideally from data
                                                        amount: row.fee,
                                                        reason: `${row.name} प्रत छापाईचे रोख जमा`
                                                    }
                                                } 
                                            })}
                                            className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-3 py-1 rounded text-sm shadow-sm transition-colors"
                                        >
                                            नमुना नं. 7
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

             {/* Footer / Pagination */}
             <div className="bg-[#267c77] p-2 flex justify-center items-center gap-1 text-white"> {/* Blue Footer from image */}
                <button className="w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded text-xs">⏮</button>
                <button className="w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded text-xs">◀</button>
                <div className="bg-white/20 px-3 py-1 rounded text-sm font-medium">1</div>
                <button className="w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded text-xs">▶</button>
                <button className="w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded text-xs">⏭</button>
                 <select className="bg-white text-black text-sm rounded px-2 py-1 ml-2">
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                </select>
            </div>
            
            {/* Bottom Action Bar */}
            <div className="bg-[#267c77] p-3 flex justify-center border-t border-white/10">
                 <button 
                    onClick={() => navigate('/asthapan/grampanchayat/print-report')}
                    className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2 rounded text-base font-medium shadow-md transition-all">
                    रिपोर्ट
                </button>
            </div>

        </div>
      </div>
    </div>
  );
};

export default DakhlUtareFeeReport;
